import { render, staticRenderFns } from "./u-loading.vue?vue&type=template&id=11df8c9e&scoped=true&"
import script from "./u-loading.vue?vue&type=script&lang=js&"
export * from "./u-loading.vue?vue&type=script&lang=js&"
import style0 from "./u-loading.vue?vue&type=style&index=0&id=11df8c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df8c9e",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-loading/u-loading.vue"
export default component.exports